import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { GlobalService } from './global.service';

@Injectable({ providedIn: 'root' })
export class ProjectSettingsService {

    constructor(public hs: HttpService, public gs: GlobalService) { }

    async get_config(university_id?: any) {
        try {
            const params: any = {};
            if (university_id) params['university_id'] = university_id;
            return await this.hs.get('/university-config/get-university-config', params);
        } catch (error: any) {
            throw error;
        }
    }

    async save_config(data: any) {
        try {
            return await this.hs.post('/university-config/save-university-config', {}, data);
        } catch (error: any) {
            throw error;
        }
    }

    async upload_file(file: File) {
        const formData = new FormData();
        formData.append('file', file, file.name);
        return await this.hs.post('/media/upload', {}, formData);
    }

    async download_receipt(payment_history_id: any) {
        try {
            return await this.hs.get('/payment/download-receipt', { payment_history_id });
        } catch (error: any) {
            throw error;
        }
    }
}
